module.exports = __webpack_public_path__ + "img/rw.408bebb0.svg";